// Studyo Today Backend
// Package studyo.today.schedules.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schedules/v1/resources/activity.proto (package studyo.today.schedules.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/schedules/v1/resources/activity.proto.
 */
export const file_studyo_today_schedules_v1_resources_activity = /*@__PURE__*/
  fileDesc("CjJzdHVkeW8vdG9kYXkvc2NoZWR1bGVzL3YxL3Jlc291cmNlcy9hY3Rpdml0eS5wcm90bxIjc3R1ZHlvLnRvZGF5LnNjaGVkdWxlcy52MS5yZXNvdXJjZXMiNAoIQWN0aXZpdHkSEwoLYWN0aXZpdHlfaWQYASABKAkSEwoLc291cmNlX25hbWUYAiABKAlCK6oCKFN0dWR5by5Ub2RheS5TY2hlZHVsZXMuR3JwYy5WMS5SZXNvdXJjZXNiBnByb3RvMw");

/**
 * Describes the message studyo.today.schedules.v1.resources.Activity.
 * Use `create(ActivitySchema)` to create a new message.
 */
export const ActivitySchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schedules_v1_resources_activity, 0);

